import { useLayoutEffect, useState } from 'react'

const COMPLIANCE_BAR_SELECTOR = '[data-compliance-bar]'

export const useComplianceBarHeight = (isEnabled = true) => {
    const [height, setHeight] = useState(0)

    useLayoutEffect(() => {
        if (!isEnabled) {
            setHeight(0)

            return
        }

        const element = document.querySelector<HTMLElement>(COMPLIANCE_BAR_SELECTOR)

        if (!element) return

        const updateHeight = () => setHeight(element.offsetHeight)
        const observer = new ResizeObserver(updateHeight)

        observer.observe(element)
        updateHeight()

        return () => observer.disconnect()
    }, [isEnabled])

    return height
}
